<template>
  <v-main>
    <v-container id="core-view" fluid>
      <sl-alert v-show="errorDataUnauthorizedAccess" type="error">
        Sorry, you are not allowed to access this content. Please, ask the Sharylist workspace
        administrator to invite you.
        <template #action>
          <v-btn outlined to="/settings">
            <v-icon left>mdi-cog</v-icon>
            Check your workspaces
          </v-btn>
        </template>
      </sl-alert>
      <sl-alert v-show="errorDataMissing" type="error">
        Oops, the content you are trying to access does not exists on our servers.
        <template #action>
          <v-btn outlined to="/settings">
            <v-icon left>mdi-cog</v-icon>
            Check your workspaces
          </v-btn>
        </template>
      </sl-alert>
      <sl-alert v-show="$vuetify.breakpoint.xsOnly" dismissible type="warning">
        Sorry, Sharylist is not optimized for small screens yet. While we are working on it, you may
        still decide to use it, but we suggest you to use a larger device.
      </sl-alert>
      <sl-toast v-model="toast.show" :message="toast.message" :color="toast.color" />
      <router-view />
    </v-container>
  </v-main>
  <!-- </v-main> -->
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Logger from '@/lib/Logger'

import SlToast from '@/components/SlToast'
import SlAlert from '@/components/SlAlert'

import App from '@/models/App'
import User from '@/models/User'
import loadedVersion from '@/version.js'

export default {
  metaInfo() {
    return {
      title: 'Sharylist',
    }
  },

  components: {
    SlToast,
    SlAlert,
  },

  data() {
    return {
      //
    }
  },

  computed: {
    ...mapState(['toast', 'errorDataUnauthorizedAccess', 'errorDataMissing']),
    ...mapState({
      userLoggedId: state => state.userLogged.id,
    }),
  },

  watch: {
    async userLoggedId(/*to, from*/) {
      // react to logged user changes...
      this.queryCreate()
    },
  },

  created() {
    this.queryCreate()
  },

  mounted() {
    this.errorsDataAccessAllSetFalse()
  },

  beforeDestroy() {
    this.queries.forEach(q => q.destroy())
  },

  methods: {
    ...mapMutations(['toastSet', 'errorDataUnauthorizedAccessSet', 'errorsDataAccessAllSetFalse']),

    queryCreate() {
      Logger.debug('CoreView - queryCreate() - userLoggedId:', this.userLoggedId)
      if (this.queries) this.queries.forEach(q => q.destroy())
      this.queries = [
        App.find({
          get: '{ frontendVersion }',
          by: {},
          onChange: data => {
            const frontendVersion = data.frontendVersion
            Logger.debug('Versione disponibile online', frontendVersion)
            Logger.debug('Versione caricata', loadedVersion)
            if (frontendVersion && loadedVersion && frontendVersion != loadedVersion) {
              if (frontendVersion != localStorage.lastVersionSearched) {
                // non ci riprovo due volte
                localStorage.setItem('lastVersionSearched', frontendVersion)
                Logger.debug('Cerco di scaricare', frontendVersion)
                window.location.reload(true)
              } else {
                Logger.debug('lastVersionSearched', localStorage.lastVersionSearched)
                Logger.debug('Multipli tentativi di scaricare ', frontendVersion)
              }
            }
          },
          onError: error => {
            Logger.error('ERROR in loading data:', error)
            this.toastSet({
              message: 'Error in loading data',
              color: 'error',
            })
          },
        }),
      ]

      if (this.userLoggedId) {
        this.queries.push(
          User.find({
            get: `{
                id
                firstName
                lastName
                email
                sessionJson
                usageLimits {
                  masterEntriesNumberMax
                  masterInstancesNumberMax
                  workspaceMastersNumberMax
                  workspaceUsersNumberMax
                  workspacesSharedNumberMax
                }
                actionsAllowed {
                  workspaceSharedCreate
                }
             }`,
            by: { id: this.userLoggedId },
            onChange: data => {
              this.$store.commit('userLoggedIn', data)
              Logger.debug(data.usageLimits)
            },
            onError: error => {
              Logger.error(error)
            },
          }),
        )
      }
    },
  },
}
</script>
